import React from 'react'
import SEO from '../../seo/SEO'
import DirectorWord_Banner from './DirectorWord_Banner/DirectorWord_Banner'
import DirectorWord_Message from './DirectorWord_Message/DirectorWord_Message'
import DirectorWord_Team from './DirectorWord_Team/DirectorWord_Team'

const DirectorWord = () => {
  return (
       <>
    <SEO />
    <div>
        <DirectorWord_Banner/>
        <DirectorWord_Message/>
        {/* <DirectorWord_Team/> */}
    </div>
    </>
  )
}

export default DirectorWord
